<template>
  <div class="games-list">
    <div class="games-list__item" @click="selectGame">
      <div class="games-list__item__content">
        <p>Catcher</p>
        <img class="games-list__item__img" src="/images/games/catcher.png">
      </div>
      <v-btn class="games-list__item__button" text>Перейти в чат Catcher</v-btn>
    </div>
    <Base--SideButtons class="games-list__buttons" :save="f" back />
  </div>
</template>

<script>

export default {
  data: () => ({
    show: false,
    game: '',
    f: () => console.log('saved')
  }),
  methods: {
    selectGame () {
      this.game = 'catcher'
      this.showGameChat(this.game)
    },
    showGameChat (game) {
      this.$router.push({
        path: `/games-chats/${game}`
      })
    }
  }
}
</script>
<style lang="scss">
  .games-list {
    display: flex;
    justify-content: space-between;
    &__item {
      width: 32%;
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
      padding: 15px;
      border-radius: 10px;
      cursor: pointer;
      &__content {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        p {
          font-size: 22px;
          font-weight: 500;
          margin: auto;
        }
      }
      &__img {
        width: 35%;
      }
      &__button {
        width: 100%;
        margin: 0px;
      }
    }
    &__buttons {
      .v-btn {
        &:last-of-type {
          display: none;
        }
      }
    }
  }
</style>
